<script lang="ts" module>
  import { tv } from 'tailwind-variants';

  import BaseBtn from '@/ui/base/BaseBtn.svelte';

  export type DropDownItem = {
    label: string;
    value: string;
    disabled?: boolean;
  };

  interface DropDownSelectProps {
    item: DropDownItem;
    selected?: boolean;
  }
</script>

<script lang="ts">
  let { selected = false, ...props }: DropDownSelectProps = $props();

  const styles = tv({
    base: 'w-full rounded-xs p-1 text-right font-sans text-sm text-c-base',
    variants: {
      selected: {
        true: 'bg-select-dropdown-H font-medium',
        false: 'bg-select-dropdown font-normal hocus:bg-select-dropdown-H',
      },
      disabled: {
        true: 'text-c-disabled hocus:bg-transparent',
        false: '',
      },
    },
  });
</script>

<BaseBtn class={styles({ selected, disabled: props.item.disabled })} disabled={props.item.disabled}
  >{props.item.label}</BaseBtn
>
